export interface OwnApp {
  appId: string;
  name: string;
  isWeb: boolean;
  // campaign platforms the app serves: one for a store app, both for a web app
  platformIds: number[];
}

// partnerAppId is the partner's app (package name on Android, store id on iOS),
// ownAppId is one of our own apps. An empty partnerAppId covers every app of
// the partner on that platform.
export interface PartnerAppExclusion {
  id: number;
  partnerId: number;
  companyName: string | null;
  platformId: number;
  partnerAppId: string;
  ownAppId: string;
  ownAppName: string;
}

// appId here is the partner app id the exclusion rows carry as partnerAppId.
export interface PartnerGame {
  appId: string;
  title: string;
  platform: string;
  iconUrl: string;
}

export interface ExclusionScope {
  platformId: number;
  partnerAppId: string;
  ownAppIds: string[];
}

export interface Platform {
  id: number;
  name: string;
}

// Backend platform ids (pkg/platform.go): 1 = Android, 2 = iOS.
export const PLATFORMS: Platform[] = [
  { id: 1, name: "Android" },
  { id: 2, name: "iOS" },
];

export const getPlatformName = (platformId: number): string =>
  PLATFORMS.find((platform) => platform.id === platformId)?.name ??
  `Platform ${platformId}`;

// An empty partner app id is the partner-wide rule for that platform.
export const ALL_PARTNER_APPS = "";

export const cellKey = (
  platformId: number,
  partnerAppId: string,
  ownAppId: string
): string => `${platformId}|${partnerAppId}|${ownAppId}`;
